import { render, staticRenderFns } from "./wxbind.vue?vue&type=template&id=de1c7a14&scoped=true"
import script from "./wxbind.vue?vue&type=script&lang=js"
export * from "./wxbind.vue?vue&type=script&lang=js"
import style0 from "./wxbind.vue?vue&type=style&index=0&id=de1c7a14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1c7a14",
  null
  
)

export default component.exports